import { action, PayloadAction } from 'typesafe-actions';
import { AuthActionTypes } from './types';
import { ActionMetaService, ActionServiceEmpty } from 'ff-shared-components-core';

/**
 * Get process access token
 */
export const fetchProcessTokenRequest = (metaData?: ActionMetaService): ActionServiceEmpty =>
	action(AuthActionTypes.FETCH_PROCESS_TOKEN_REQUEST, undefined, metaData);

export const fetchProcessTokenSuccess = (accessToken: string): PayloadAction<string, string> =>
	action(AuthActionTypes.FETCH_PROCESS_TOKEN_SUCCESS, accessToken);
